<script>
export default {
  props: {
    entries: {
      type: Array,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      totalRows: this.entries.length,
      tableEntries: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      selectedStatus: 0,
      statusOptions: [
        { value: 0, text: "All" },
        { value: 1, text: "Not Posted" },
        { value: 2, text: "Posted" },
      ],
      fields: [
        {
          key: "items",
          label: " ",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "jevDate",
          label: "JEV Date",
          sortable: true,
        },
        {
          key: "jevNumber",
          label: "JEV No.",
        },
        {
          key: "description",
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "isPosted",
          label: "Status",
          sortable: true,
        },
        {
          key: "actions",
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.entries.length;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    calculateTotalDebit(record) {
      let sum = 0;
      record.forEach((item) => {
        sum += item.debit;
      });
      return sum;
    },
    calculateTotalCredit(record) {
      let sum = 0;
      record.forEach((item) => {
        sum += item.credit;
      });
      return sum;
    },
    viewItems(data) {
      data.item.showDetails = !data.item.showDetails;
      if (data.item.showDetails) {
        this.$store
          .dispatch("subsidiaryledger/getSubsidiaryLedgerByJevEntry", data.item.id)
          .then((response) => {
            if (response.data.error) {
              return this.showToast(response.data.errorMessage, "error");
            }
            data.item.subsidiaryLedgers = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.showToast(
              "There was an error on fetching subsidiary ledger for this JEV entry.",
              "error"
            );
          });
      }

      data.toggleDetails();
    },
    test() {
      return "test";
    },
    updateStatus() {
      this.changeStatus();
    },
    changeStatus() {
      if (this.selectedStatus === 0) {
        this.tableEntries = JSON.parse(JSON.stringify(this.entries));
        this.totalRows = JSON.parse(JSON.stringify(this.entries)).length;
        return;
      }
      if (this.selectedStatus === 1) {
        this.tableEntries = JSON.parse(JSON.stringify(this.entries)).filter(
          (item) => !item.isPosted
        );
        this.totalRows = JSON.parse(JSON.stringify(this.entries)).filter(
          (item) => !item.isPosted
        ).length;
        return;
      }
      if (this.selectedStatus === 2) {
        this.tableEntries = JSON.parse(JSON.stringify(this.entries)).filter(
          (item) => item.isPosted
        );
        this.totalRows = JSON.parse(JSON.stringify(this.entries)).filter(
          (item) => item.isPosted
        ).length;
        return;
      }
    },
  },
  watch: {
    entries(newValue) {
      this.tableEntries = newValue;
    },
  },
  created() {
    this.tableEntries = this.entries;
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div id="tickets-table_length" class="dataTables_length d-flex">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              class="form-select mx-1"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select>
          </label>
          <label class="ms-2 mb-0">
            <b-form-select
              class="form-select"
              :options="statusOptions"
              v-model="selectedStatus"
              @change="changeStatus"
            ></b-form-select>
          </label>

          <div class="ms-3 mb-0 pt-0 text-center">
            <small class="d-block">Posted:</small>
            <strong class="text-success font-size-15">{{
              entries.filter((item) => item.isPosted).length
            }}</strong>
          </div>
          <div class="ms-3 mb-0 pt-0 text-center">
            <small class="d-block">Not Posted:</small>
            <strong class="text-warning font-size-15">{{
              entries.filter((item) => !item.isPosted).length
            }}</strong>
          </div>
        </div>
      </div>
      <!-- Search -->
      <div class="col-6">
        <div id="tickets-table_filter" class="dataTables_filter text-start text-md-end">
          <b-button
            size="sm"
            class="me-2"
            @click="$emit('viewModal', type)"
            variant="purple"
          >
            <i class="bx bx-file font-size-15 align-middle me-2"></i> Print Journal
          </b-button>
          <label class="d-inline-flex align-items-center">
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Search JEV Entry..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <!-- End search -->
    </div>

    <div class="row">
      <!-- table data -->
      <div class="col-lg-12">
        <div class="custom-table-responsive">
          <b-table
            class="table project-list-table align-middle table-borderless"
            :items="tableEntries"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            :busy="!$store.state.jev.isJevLoaded"
            @filtered="onFiltered"
            show-empty
          >
            <template #empty="scope">
              <div class="text-center">
                <h5 class="text-secondary">{{ scope.emptyText }}</h5>
              </div>
            </template>
            <template #table-busy>
              <div class="d-flex justify-content-center align-items-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(isPosted)="row">
              <div class="d-flex align-items-center">
                <div
                  class="badge font-size-12"
                  :class="{
                    'badge-soft-success': row.item.isPosted,
                    'badge-soft-warning': !row.item.isPosted,
                  }"
                >
                  {{ row.item.isPosted ? "POSTED" : "NOT POSTED" }}
                </div>
              </div>
            </template>
            <template #cell(action)="row">
              <div
                class="d-flex align-items-center justify-content-center"
                @click="showDtls(row)"
              >
                <i
                  class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                  :class="{
                    'rotate-90': row.item.rotateChevy,
                  }"
                ></i>
              </div>
            </template>
            <template #cell(items)="row">
              <span role="button" @click="viewItems(row)">
                <i
                  class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                  :class="{
                    'rotate-90': row.item.showDetails,
                  }"
                ></i>
              </span>
            </template>
            <template #cell(jevNumber)="row">
              <span class="text-info"
                ><strong>{{ row.item.jevNumber }}</strong></span
              >
            </template>
            <template #cell(jevDate)="row">
              <span>{{
                row.item.isPosted ? formatDateCustom(row.item.dateTimePosted) : ""
              }}</span>
            </template>
            <template #cell(actions)="row">
              <b-button variant="link" size="sm" :id="`popover-target-${row.item.id}`">
                <i class="fas fa-ellipsis-h"></i>
              </b-button>
              <b-popover
                :target="`popover-target-${row.item.id}`"
                id="menu"
                triggers="hover blur"
                placement="leftbottom"
                variant="secondary"
                custom-class="p-0 p-custom-class"
              >
                <b-list-group class="w-100 fit">
                  <b-list-group-item
                    button
                    action
                    @click="$emit('postJev', row.item)"
                    v-if="!row.item.isPosted"
                  >
                    <i
                      class="bx bx-check-square text-success align-middle me-2 font-size-16"
                    ></i
                    ><span class="align-middle">Post</span>
                  </b-list-group-item>
                  <b-list-group-item
                    button
                    action
                    @click="$emit('addtosl', row.item)"
                    v-if="row.item.isPosted"
                  >
                    <i
                      class="bx bx-right-arrow-alt text-success align-middle me-2 font-size-16"
                    ></i
                    ><span class="align-middle">Add to SL</span>
                  </b-list-group-item>
                  <b-list-group-item
                    button
                    action
                    @click="$emit('edit', row.item)"
                    v-if="!row.item.isPosted"
                  >
                    <i class="bx bx-edit text-warning align-middle me-2 font-size-16"></i>
                    <span class="align-middle">Edit</span>
                  </b-list-group-item>
                  <b-list-group-item
                    button
                    action
                    @click="$emit('deleteItem', row.item)"
                    v-if="!row.item.isPosted"
                  >
                    <i class="bx bxs-trash text-danger align-middle me-2 font-size-16"></i
                    ><span class="align-middle">Delete</span>
                  </b-list-group-item>
                </b-list-group>
              </b-popover>
            </template>
            <template #row-details="row">
              <b-card>
                <b-card-title
                  >JEV No.
                  <span class="text-warning">{{ row.item.jevNumber }}</span></b-card-title
                >
                <b-card-text>
                  <hr />
                  <b-row>
                    <b-col lg="3">
                      <!-- Fund Source -->
                      <p>
                        <small class="d-block">Fund Source:</small>
                        <span class="text-warning">{{
                          row.item.fundSource ? row.item.fundSource.sourceName : "---"
                        }}</span>
                      </p>
                      <!-- Description -->
                      <p>
                        <small class="d-block">Description:</small>
                        <span class="text-warning text-wrap">{{
                          row.item.description
                        }}</span>
                      </p>

                      <p>
                        <small class="d-block">Reviewing Report:</small>
                        <span class="text-warning text-wrap">{{
                          row.item.reviewingReport
                        }}</span>
                      </p>

                      <p>
                        <small class="d-block">Notes:</small>
                        <span class="text-warning text-wrap">{{ row.item.notes }}</span>
                      </p>
                      <!-- Jev Date -->
                      <p>
                        <small class="d-block">JEV Date:</small>
                        <span class="text-warning">{{
                          formatDateCustom(row.item.jevDate)
                        }}</span>
                      </p>
                      <!-- Cycle -->
                      <p>
                        <small class="d-block">Cycle:</small>
                        <span class="text-warning">{{ row.item.cycle }}</span>
                      </p>

                      <p v-if="row.item.type.toLowerCase() !== 'adj'">
                        <small class="d-block">Officer:</small>
                        <span class="text-warning">{{ row.item.payee }}</span>
                      </p>
                      <div v-if="row.item.type.toLowerCase() === 'chr'">
                        <p>
                          <small class="d-block">OR:</small>
                          <span class="text-warning">{{ row.item.orNumber }}</span>
                        </p>
                        <p>
                          <small class="d-block">OR Date:</small>
                          <span class="text-warning">{{
                            formatDateCustom(row.item.orDate)
                          }}</span>
                        </p>
                      </div>

                      <div
                        v-if="['chd', 'ckd', 'ada'].includes(row.item.type.toLowerCase())"
                      >
                        <p>
                          <small class="d-block">Disbursement Number:</small>
                          <span class="text-warning">{{ row.item.dvNumber }}</span>
                        </p>
                        <div v-if="row.item.type.toLowerCase() !== 'chd'">
                          <p>
                            <small class="d-block">Check Number:</small>
                            <span class="text-warning">{{ row.item.checkNumber }}</span>
                          </p>
                          <p>
                            <small class="d-block">Check Bank Name:</small>
                            <span class="text-warning">{{ row.item.checkBankName }}</span>
                          </p>

                          <p>
                            <small class="d-block">Check Date:</small>
                            <span class="text-warning">{{
                              formatDateCustom(row.item.checkDate)
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col lg="9">
                      <p>
                        <small class="d-block">Type:</small>
                        <span class="text-warning">{{ row.item.type }}</span>
                      </p>
                      <p>
                        <small class="d-block">Responsibility Center:</small>
                        <span class="text-warning">{{
                          row.item.responsibilityCenter
                        }}</span>
                      </p>
                      <h4 class="card-title text-info">
                        <u>JEV Entry Items</u>
                      </h4>
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th>UACS</th>
                            <th>Account</th>
                            <th class="text-end" width="150px">Debit</th>
                            <th class="text-end" width="150px">Credit</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="account in row.item.jevDetails" :key="account.id">
                            <td>
                              <span class="badge rounded-pill badge-soft-success">{{
                                account.account ? account.account.uacs : "---"
                              }}</span>
                            </td>
                            <td>
                              <span>{{
                                account.account ? account.account.accountName : "---"
                              }}</span>
                            </td>
                            <td class="text-right">
                              {{ formatCurrency(account.debit) }}
                            </td>
                            <td class="text-right">
                              {{ formatCurrency(account.credit) }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2"><strong>Total</strong></td>
                            <td class="text-right text-info">
                              {{
                                formatCurrency(calculateTotalDebit(row.item.jevDetails))
                              }}
                            </td>
                            <td class="text-right text-info">
                              {{
                                formatCurrency(calculateTotalCredit(row.item.jevDetails))
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="mt-4 mb-0">
                        <h4 class="card-title text-info"><u>Subsidiary Ledger(s)</u></h4>
                        <table class="table">
                          <tr>
                            <th>Account</th>
                            <th>Subsidiary Ledger</th>
                            <th>Type</th>
                            <th>Client Type</th>
                          </tr>
                          <tr
                            v-for="ledger in row.item.subsidiaryLedgers"
                            :key="ledger.id"
                          >
                            <td>
                              <span class="badge rounded-pill badge-soft-success">{{
                                ledger.subsidiaryLedger.account
                                  ? ledger.subsidiaryLedger.account.uacs
                                  : "-"
                              }}</span>
                              -
                              <span>{{
                                ledger.subsidiaryLedger.account
                                  ? ledger.subsidiaryLedger.account.accountName
                                  : "-"
                              }}</span>
                            </td>
                            <td>
                              {{ ledger.subsidiaryLedger.title }}
                            </td>
                            <td>{{ ledger.subsidiaryLedger.type }}</td>
                            <td>{{ ledger.subsidiaryLedger.referenceType }}</td>
                          </tr>
                        </table>
                      </div>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-card>
            </template>
          </b-table>
        </div>
      </div>
      <!-- table data -->
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>
